import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Redirect, withRouter } from 'react-router-dom';
import Button from '@saucelabs/sl-component-buttons';
import { FormAlert } from '@saucelabs/sl-component-form';
import { actions as modalActions } from '@saucelabs/sl-container-modal';

import FormTitle from '../components/FormTitle';
import ChangeEmailModal from '../components/ChangeEmailModal';
import { CHANGE_EMAIL_MODAL } from './../ducks/types';
import * as operations from './../ducks/operations';
import Styles from './SendVerificationEmailContainer.styles';

const SendVerificationEmailContainer = ({
  changeEmail,
  errorMessage,
  email,
  sendVerificationEmail,
  showModal,
  username,
  verified,
}) => {
  if (verified) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <div>
      <ChangeEmailModal
        changeEmail={changeEmail}
        username={username}
      />
      <Helmet>
        <title>Verify Email</title>
      </Helmet>
      <FormTitle>Verify your email to begin using Sauce</FormTitle>
      <FormAlert type="danger">{errorMessage}</FormAlert>
      <div>
        <p>
          {'We\'ve sent a link to '}
          <strong>{email}</strong>
          {' for you to use to verify your email address. If you don\'t see the email,'}
          {' be sure to check your spam folder. You can also resend the email or change the email address'}
          {' you\'re using, if need be. If all else fails, drop us a line at '}
          <a href="mailto:help@saucelabs.com">help@saucelabs.com</a>
          {'.'}
        </p>
      </div>
      <div className={Styles['buttons-wrapper']}>
        <Button
          category="action"
          onClick={() => sendVerificationEmail({ username })}
        >
          Resend verification email
        </Button>
        <Button
          category="primary"
          onClick={() => showModal(CHANGE_EMAIL_MODAL)}
        >
          Change email address
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = ({ user }, { location: { state } }) => ({
  email: user.get('email'),
  username: user.get('username'),
  errorMessage: state && state.error,
  verified: user.get('verified'),
});

const mapDispatchToProps = {
  changeEmail: operations.changeEmail,
  sendVerificationEmail: operations.sendVerificationEmail,
  showModal: modalActions.showModal,
};

SendVerificationEmailContainer.propTypes = {
  changeEmail: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  sendVerificationEmail: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  verified: PropTypes.bool.isRequired,
};

SendVerificationEmailContainer.defaultProps = {
  errorMessage: null,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SendVerificationEmailContainer),
);
export { SendVerificationEmailContainer, mapDispatchToProps };
